module.exports = __webpack_public_path__ + "img/Colm.806c52ca.jpg";